document.addEventListener("DOMContentLoaded", () => {
  // promotional banner
  const carousel = document.querySelector(".pr-banner-carousel");

  if (carousel) {
    const scrollLeftBtn = document.querySelector(".pr-scroll-left");
    const scrollRightBtn = document.querySelector(".pr-scroll-right");
    const scrollArrows = document.querySelector(".pr-scroll-arrows");
    const firstCarouselScroll = carousel?.scrollLeft || 0;
    const updateScrollVisibility = () => {
      if (!carousel || !scrollArrows) return;

      if (carousel.scrollWidth > carousel.clientWidth) {
        scrollArrows.style.display = "block";
      } else {
        scrollArrows.style.display = "none";
      }

      updateArrowStates();
    };

    const updateArrowStates = () => {
      const scrollLeft = carousel.scrollLeft;
      const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
      if (scrollLeft <= firstCarouselScroll) {
        scrollLeftBtn.style.display = "none";
      } else {
        scrollLeftBtn.style.display = "inline-block";
      }

      if (scrollLeft >= maxScrollLeft - 1) {
        scrollRightBtn.style.display = "none";
      } else {
        scrollRightBtn.style.display = "inline-block";
      }
    };

    updateScrollVisibility();

    window.addEventListener("resize", updateScrollVisibility);

    carousel.addEventListener("scroll", updateArrowStates);

    scrollRightBtn?.addEventListener("click", () => {
      carousel.scrollBy({ left: 300, behavior: "smooth" });
    });

    scrollLeftBtn?.addEventListener("click", () => {
      carousel.scrollBy({ left: -300, behavior: "smooth" });
    });
  }

  // two videos section

  const hoverVideos = document.querySelectorAll(".two_vid-block");

  hoverVideos.forEach((block) => {
    block.addEventListener("mouseenter", (e) => {
      const video = block.querySelector("video");
      if (!video) return;
      video.play();
    });
    block.addEventListener("mouseleave", () => {
      const video = block.querySelector("video");
      if (!video) return;
      video.pause();
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!video) return;

        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    },
    {
      threshold: 1,
    }
  );
  if (window.matchMedia("(max-width: 767px)").matches) {
    document.querySelectorAll(".two_vid-block video").forEach((video) => {
      observer.observe(video);
    });
  }
});

document.querySelectorAll(".two_vid-block video").forEach((video) => {
  video.play().then(() => {
    setTimeout(() => {
      video.pause();
      video.currentTime = 0;
    }, 1000);
  });
});
// footer

const toggles = document.querySelectorAll(".re-footer-accordion-toggle");

toggles.forEach((toggle) => {
  toggle.addEventListener("click", function () {
    const parent = this.parentElement;
    const isOpen = parent.classList.contains("active");

    if (!isOpen) {
      parent.classList.add("active");
    } else {
      parent.classList.remove("active");
    }
  });
});

// --------------- ------- logos slider ---------------- -------------
const SliderSelector = ".logos-slick-container";
const $slider = $(SliderSelector);
const loopEnabled =
  $slider.data("loop-enabled") === true ||
  $slider.data("loop-enabled") === "true";

function initOrDestroySlider() {
  const isMobile = window.innerWidth < 768;

  if ((loopEnabled || isMobile) && !$slider.hasClass("slick-initialized")) {
    $slider.slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: $slider.data("speed") || 3000,
      cssEase: "linear",
      variableWidth: true,
      centerMode: true,
      arrows: false,
      pauseOnHover: false,
      draggable: false,
      swipe: false,
      touchMove: false,
    });
  } else if (
    !loopEnabled &&
    !isMobile &&
    $slider.hasClass("slick-initialized")
  ) {
    $slider.slick("unslick");
  }
}

initOrDestroySlider();

let resizeTimeout;
window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initOrDestroySlider, 200);
});

//---------------------------------------------------  info video/img section

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".media--slick").forEach((sliderEl) => {
    const section = sliderEl.closest(".info-video-section");
    if (!section) return;

    const pauseBtn = section.querySelector(".play-button");
    const bar = section.querySelector(".info-bar");
    const volumeToggle = section.querySelector(".volume-toggle");
    const infoGrid = section.querySelector(".info-text-grid");
    const infoTexts = section.querySelectorAll(".info-text-col");
    let duration = parseInt(section.dataset.duration, 10) || 2000;
    const pauseWhenPlaying = section.dataset.pauseWhenPlaying === "true";

    let paused = false;
    let startTime = null;
    let barRAF = null;

    function animateBar(ts) {
      startTime ??= ts;
      const elapsed = ts - startTime;
      const progress = Math.min((elapsed / duration) * 100, 100);
      if (bar) bar.style.width = `${progress}%`;
      if (progress >= 100) {
        startTime = null;
        bar.style.width = "0%";
      }
      barRAF = requestAnimationFrame(animateBar);
    }

    function startProgress() {
      cancelAnimationFrame(barRAF);
      startTime = null;
      if (bar) bar.style.width = "0%";
      barRAF = requestAnimationFrame(animateBar);
    }

    function resetAutoplay() {
      // console.log('resetAutoplay');
      $(sliderEl).slick("slickSetOption", "autoplay", true, true);
      setTimeout(() => $(sliderEl).slick("slickPlay"), 0);
    }
    function togglePause(userClicked = false) {
      const $s = $(sliderEl);
      // console.log("barRAF: ",barRAF)
      console.log("togglePause", paused);
      if (!$s.hasClass("slick-initialized")) return;

      paused = !paused;

      // console.log('togglePause', paused);
      const slick = $s.slick("getSlick");
      const slide = slick.$slides.get(slick.currentSlide);
      const video = slide?.querySelector("video");

      if (paused) {
        $s.slick("slickPause");
        pauseBtn?.classList.add("paused");
        if (video) video.pause();
        cancelAnimationFrame(barRAF);
      } else {
        pauseBtn?.classList.remove("paused");
        setTimeout(() => $s.slick("slickPlay"), 10);
        if (video && video.paused) video.play();
        barRAF = requestAnimationFrame(animateBar);
      }
    }

    function updateSlickDuration(newDuration) {
      duration = Math.ceil(newDuration);
      const $slider = $(sliderEl);
      const slickInstance = $slider.slick("getSlick");

      if (slickInstance) {
        // console.log('updateSlickDuration', duration);
        $slider.slick("slickSetOption", "autoplaySpeed", duration, true);
        resetAutoplay();
      }
    }

    function updateTextBlock(curIdx) {
      infoTexts.forEach((t) => t.classList.remove("active"));
      const active = section.querySelector(
        `.info-text-col[data-block-id="${curIdx + 1}"]`
      );
      active?.classList.add("active");

      if (!infoGrid) return;
      const target = infoGrid.querySelectorAll(".info-text-col")[curIdx];
      infoGrid.scrollLeft = target
        ? target.offsetLeft - infoTexts[0].offsetLeft
        : 0;
    }

    function onSlideChange(video, curIdx) {
      if (video) {
        video.muted = true;
        const videoDuration = video.duration || 0;
        const $s = $(sliderEl);
        // pause the slider if a video exists

        $s.slick("slickPause");
        if (pauseWhenPlaying) {
          // console.log("pauseWhenPlaying is true");
          // togglePause();
          // paused = true;
          const schedule = () => {
            video.play().catch(() => {});
            setTimeout(() => {
              video.pause();
              video.currentTime = 0;
              if (!paused) {
                $(sliderEl).slick("slickNext");
              }
              // togglePause();
              // paused = false;
            }, videoDuration * 1000);
          };
          video.readyState >= 1
            ? schedule()
            : video.addEventListener("loadedmetadata", schedule, {
                once: true,
              });
        }
      }
      updateTextBlock(curIdx);
    }

    $(sliderEl)
      .on("init", (e, slick, curr) => {
        const slide = slick.$slides.get(slick.currentSlide);
        const video = slide?.querySelector("video");
        if (volumeToggle)
          volumeToggle.style.display = "none" ? "inline-flex" : "none";
        if (video) {
          video.muted = true;
          video.play().catch(() => {});
          const videoDuration = Number.isFinite(video.duration)
            ? video.duration * 1000
            : duration;
          // updateSlickDuration(videoDuration);
        } else {
          const fallbackDuration =
            parseInt(section.dataset.duration, 10) || 2000;
          // updateSlickDuration(fallbackDuration);
        }
        startProgress();
        updateTextBlock(slick.currentSlide);
      })
      .on("afterChange", (e, slick, curr) => {
        const slide = slick.$slides.get(curr);
        const video = slide?.querySelector("video");

        if (video) {
          const videoDuration = Number.isFinite(video.duration)
            ? video.duration * 1000
            : duration;
          updateSlickDuration(videoDuration);
          onSlideChange(video, curr);
          volumeToggle.style.display = "inline-flex";
        } else {
          const fallbackDuration =
            parseInt(section.dataset.duration, 10) || 2000;
          updateSlickDuration(fallbackDuration);
          volumeToggle.style.display = "none";
        }
        startProgress();
      })
      .on("beforeChange", (e, slick, curr, nextslide) => {
        resetAutoplay();
        cancelAnimationFrame(barRAF);
        toggleMuteIcons(true);
        const vid = slick.$slides.get(curr)?.querySelector("video");
        if (vid) {
          vid.pause();
          vid.currentTime = 0;
        }
      });
    $(sliderEl).slick({
      autoplay: true,
      autoplaySpeed: duration,
      arrows: false,
      dots: false,
      infinite: true,
      speed: 800,
      fade: false,
      pauseOnHover: false,
      pauseOnFocus: false,
    });

    pauseBtn?.addEventListener("click", () => togglePause());

    infoTexts.forEach((textCol, index) => {
      textCol.addEventListener("click", () => {
        // console.log('text clicked', index);
        $(sliderEl).slick("slickGoTo", index);
        paused = false;
        pauseBtn?.classList.remove("paused");
        infoTexts.forEach((col) => col.classList.remove("active"));
        textCol.classList.add("active");
        updateTextBlock(index);
      });
    });
    function toggleMuteIcons(muted) {
      const [iconOn, iconOff] = volumeToggle.querySelectorAll("span");
      iconOn.style.display = muted ? "inline-flex" : "none";
      iconOff.style.display = muted ? "none" : "inline-flex";
    }
    volumeToggle?.addEventListener("click", () => {
      const slick = $(sliderEl).slick("getSlick");
      const slide = slick.$slides.get(slick.currentSlide);
      const video = slide?.querySelector("video");
      if (!video) return;

      video.muted = !video.muted;
      toggleMuteIcons(video.muted);
    });
  });
});

// --------------------------------------- mega menu --------------------------
document.addEventListener("DOMContentLoaded", function () {
  const megaMenus = document.querySelectorAll(".mega-menu");
  let closeTimer;

  const closeAll = () => {
    clearTimeout(closeTimer);
    megaMenus.forEach((menu) => menu.removeAttribute("open"));
  };

  megaMenus.forEach((menu) => {
    menu.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
      menu.setAttribute("open", "");
    });
    menu.addEventListener("mouseleave", () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => menu.removeAttribute("open"), 250);
    });
  });

  // Close as soon as a scroll gesture starts (wheel/touchmove fire before the
  // page actually scrolls, so the panel closes before it can expand).
  ["wheel", "touchmove", "scroll"].forEach((evt) =>
    window.addEventListener(evt, closeAll, { passive: true })
  );
});

// mobile menu rewards block
document.addEventListener("DOMContentLoaded", function () {
  const rewardsLink = document.querySelector(".rewards-block__join");
  const rewardsBlockHeading = document.querySelector(".rewards-block__title");
  const rewardsSubheading = document.querySelector(".rewards-block__subtitle");
  const rewardsLoginText = document.querySelector(".rewards-block__loginText");
  if (
    window.rewardsDropdownSettings &&
    window.rewardsDropdownSettings.loggedIn == "false"
  ) {
    if (rewardsLink) {
      rewardsLink.textContent =
        window.rewardsDropdownSettings.rewardsButtonText ?? "JOIN NOW";
      rewardsLink.href =
        window.rewardsDropdownSettings.rewardsButtonUrl ?? "/pages/loyalty";
      console.log("rewardsLink", rewardsLink.href);
      console.log(
        "rewardsLink text",
        window.rewardsDropdownSettings.rewardsButtonUrl
      );
    }
    if (rewardsBlockHeading) {
      rewardsBlockHeading.textContent =
        window.rewardsDropdownSettings.rewardsHeading ??
        "PATTERN BEAUTY REWARDS";
    }
    if (rewardsSubheading) {
      rewardsSubheading.textContent =
        window.rewardsDropdownSettings.rewardsSubheading ??
        "Earn 1 point for every $1 you spend";
    }
    if (rewardsLoginText) {
      rewardsLoginText.textContent =
        window.rewardsDropdownSettings.rewardsLoginText ?? "Already a member?";
    }
  }
});

// -------------------------------------- product  card variants options

// create div to contain the mobile popup
//
let MobilePopupElement = document.getElementById(
  "mobile-variant-popup-container"
);
function generateSrcset(baseUrl) {
  const widths = [165, 360, 533, 720, 940, 1066, 2000];
  const srcset = widths.map((w) => `${baseUrl}&width=${w} ${w}w`).join(",");
  return srcset;
}
function initProductVariantSelectors() {
  document
    .querySelector(".mobile-variant-popup-header button")
    ?.addEventListener("click", function () {
      MobilePopupElement.classList.remove("active-mobile-popup");
    });

  document.querySelectorAll(".variant-selector__trigger").forEach((btn) => {
    if (btn.dataset.variantSelectorInitialized === "true") return;
    btn.dataset.variantSelectorInitialized = "true";

    btn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      isMobile = window.matchMedia("(width <= 767px)").matches;

      const form = this.closest(".product-form");

      if (!isMobile) {
        form
          .querySelector(".product-form__variant-selector")
          .classList.remove("hidden");
        this.classList.add("hidden");
        form
          .querySelector(".product-form__buttons .product-form__submit")
          .classList.remove("hidden");
      } else {
        const mobilePopup = form.querySelector(
          ".product-form__variant-mobile-selector-visually-hidden > div"
        );

        if (mobilePopup) {
          const mobilePopupContent = MobilePopupElement.querySelector(
            ".mobile-variant-popup-content"
          );
          mobilePopupContent.innerHTML = "";
          const clone = mobilePopup.cloneNode(true);
          mobilePopupContent.appendChild(clone);
          MobilePopupElement.classList.add("active-mobile-popup");
        }
      } // change the variant image
      const firstMediaImage = this.closest(".card--media")?.querySelector(
        ".card__inner .card__media img"
      );

      if (firstMediaImage) {
        const newSrc = this.dataset.variantImage;

        if (newSrc) {
          const srcset = generateSrcset(newSrc);
          firstMediaImage.setAttribute("src", newSrc);
          firstMediaImage.setAttribute("srcset", srcset);
        }
      }
    });
  });

  document.querySelectorAll(`.variant__option`).forEach((radio) => {
    radio.addEventListener("change", function () {
      const form = this.closest(".product-form");
      const variantInput = form.querySelector(".product-form__variant-id");
      const priceCurrent = form.querySelector(".button__price-current");
      const priceOriginal = form.querySelector(".button__price-original");
      const priceContainer = form.querySelector(".button__price");
      const variantImageUrl = this.closest("label").dataset.variantImage;
      const variantBadges = this.closest(".card--media")?.querySelectorAll(
        ".variant_badge_text"
      );

      const label = this.closest("label");
      variantInput.value = this.value;
      form.querySelector('input[name="id"]').value = this.value;

      if (priceCurrent) {
        priceCurrent.textContent = this.dataset.price;
      }
      if (label) {
        form.querySelectorAll("label").forEach((elem) => {
          elem.classList.remove("active-option");
          document
            .querySelector(
              `.variant-mobile-selector label[for='${elem
                .querySelector("input")
                ?.getAttribute("id")}']`
            )
            ?.classList.remove("active-option");
        });
        label.classList.add("active-option");
        document
          .querySelector(
            `.variant-mobile-selector label[for='${label
              .querySelector("input")
              .getAttribute("id")}']`
          )
          ?.classList.add("active-option");
      }

      if (this.dataset.comparePrice) {
        if (!priceOriginal) {
          const newPrice = document.createElement("span");
          newPrice.className = "button__price-original utility-small";
          newPrice.textContent = this.dataset.comparePrice;
          priceContainer.appendChild(newPrice);
        } else {
          priceOriginal.textContent = this.dataset.comparePrice;
        }
      } else {
        if (priceOriginal) {
          priceOriginal.remove();
        }
      }
      // change the image
      if (variantImageUrl) {
        const variantImage = this.closest(".card--media")?.querySelector(
          ".card__inner .card__media img"
        );

        if (variantImage) {
          variantImage.setAttribute("src", variantImageUrl);
          const srcset = generateSrcset(variantImageUrl);
          variantImage.setAttribute("srcset", srcset);
        }
      }
      //  show/hide variant badge
      variantBadges?.forEach((badge) => {
        const badgeVariantId = badge.dataset.badgeVariantId;
        if (badgeVariantId == this.value) {
          badge.style.display = "block";
        } else {
          badge.style.display = "none";
        }
      });
    });
  });
}

// product card images slide
document.addEventListener("DOMContentLoaded", function () {
  const cardMediaContainers = document.querySelectorAll(".card__media");
  if (cardMediaContainers.length > 0) {
    initCardMediaSlides(cardMediaContainers);
    initProductVariantSelectors();
  } else {
    const observer = new MutationObserver(() => {
      const cardMedia = document.querySelectorAll(".card__media");
      if (cardMedia.length === 0) return;
      initCardMediaSlides(cardMedia);
      initProductVariantSelectors();
      observer.disconnect();
      if (window.yotpo) yotpo.refreshWidgets();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    setTimeout(() => observer.disconnect(), 20000);
  }
  function initCardMediaSlides(cardMedia) {
    cardMedia.forEach((cardMedia) => {
      const slider = cardMedia.querySelector(".media--slider");
      if (!slider) return;
      const slides = slider.querySelectorAll(".media__slide");
      const prevBtn = cardMedia.querySelector(".media__nav--prev");
      const nextBtn = cardMedia.querySelector(".media__nav--next");
      const dots = cardMedia.nextSibling.querySelectorAll(
        ".media__progress-dot"
      );

      let index = 0;
      let firstClick = true;
      let startX = 0;
      let currentX = 0;

      const updateSlides = () => {
        slides.forEach((slide, i) => {
          slide.classList.toggle("is-active", i === index);
        });
        dots?.forEach((dot, i) => {
          dot.classList.toggle("is-active", i === index);
        });
      };

      cardMedia.addEventListener("mouseenter", () => {
        if (slides.length > 1 && window.innerWidth >= 768) {
          index = 1;
          updateSlides();
        }
      });

      cardMedia.addEventListener("mouseleave", () => {
        if (window.innerWidth >= 768) {
          firstClick = true;
          index = 0;
          updateSlides();
        }
      });

      // Arrow nav
      nextBtn?.addEventListener("click", (e) => {
        e.stopPropagation();
        if (firstClick) {
          index = 1;
          firstClick = false;
        }
        index = (index + 1) % slides.length;
        updateSlides();
      });

      prevBtn?.addEventListener("click", (e) => {
        e.stopPropagation();
        index = (index - 1 + slides.length) % slides.length;
        updateSlides();
      });

      // slider.addEventListener("touchstart", (e) => {
      //   startX = e.touches[0].clientX;
      // });

      // slider.addEventListener("touchmove", (e) => {
      //   currentX = e.touches[0].clientX;
      // });

      // slider.addEventListener("touchend", () => {
      //   const diffX = startX - currentX;
      //   if (Math.abs(diffX) > 50) {
      //     if (diffX > 0) {
      //       // swipe left
      //       index = (index + 1) % slides.length;
      //     } else {
      //       // swipe right
      //       index = (index - 1 + slides.length) % slides.length;
      //     }
      //     updateSlides();
      //   }
      // });
    });
  }
});

function loadCountdownDeps(cb) {
  function l(id, src, next) {
    if (document.getElementById(id)) {
      if (next) next();
      return;
    }
    var s = document.createElement("script");
    s.id = id;
    s.src = src;
    s.onload = next;
    document.head.appendChild(s);
  }
  l(
    "moment-lib",
    "https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.22.2/moment.min.js",
    function () {
      l(
        "moment-tz-lib",
        "https://cdnjs.cloudflare.com/ajax/libs/moment-timezone/0.5.21/moment-timezone-with-data.min.js",
        function () {
          l(
            "jquery-countdown-lib",
            "https://cdnjs.cloudflare.com/ajax/libs/jquery.countdown/2.2.0/jquery.countdown.min.js",
            cb
          );
        }
      );
    }
  );
}

// swiper

class MobileSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.initOrDestroy();
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    if (this.swiper) this.swiper.destroy(true, true);
  }

  handleResize() {
    this.initOrDestroy();
  }

  initOrDestroy() {
    console.log("init swiperrrr");
    const isMobile = window.innerWidth <= 768;
    const container = this.querySelector(".swiper");

    if (isMobile && !this.swiper && container) {
      this.swiper = new Swiper(container, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
      });
    } else if (!isMobile && this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define("mobile-slider", MobileSlider);
